import ListGroup from 'react-bootstrap/ListGroup';

const skills = [
  {
    item: `Python (Programming Language), Multithreading and processing, and Distributed Systems`,
    id: 1
  },
  {
    item: `Data manipulation, processing, and detail orientation`,
    id: 2
  },
  {
    item: `HTML5, CSS3, JavaScript`,
    id: 3
  },
  {
    item: `Microsoft Excel (including VBA and Excel Formulas) and Microsoft Word`,
    id: 4
  },
  {
    item: `Linux, Unix, and Shell Command Line/Terminal`,
    id: 5
  },
  {
    item: `Design patterns and AGILE development`,
    id: 6
  },
  {
    item: `Server Side Rendering and Application State Management`,
    id: 7
  },
  {
    item: `Determination and hard working individualism`,
    id: 8
  },
  {
    item: `UX/UI & Accessibility Design`,
    id: 9
  },
  {
    item: `Git (Git command line tool, Github), Communication, and Teamwork`,
    id: 10
  }
];

const skillItems = skills.map(skill =>
  <ListGroup.Item as='li' key={skill.id}>
    {skill.item}
  </ListGroup.Item>
);

function Skills() {
  return (
    <div>
      <h2>Skills</h2>
      <ListGroup variant='flush'>
        {skillItems}
      </ListGroup>
    </div>
  );
}

export default Skills;
